import { render, staticRenderFns } from "./ShopAuthentication.vue?vue&type=template&id=065840d0&scoped=true"
import script from "./ShopAuthentication.vue?vue&type=script&lang=js"
export * from "./ShopAuthentication.vue?vue&type=script&lang=js"
import style0 from "./ShopAuthentication.vue?vue&type=style&index=0&id=065840d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065840d0",
  null
  
)

export default component.exports